/* esm.sh - applesauce-common@5.2.0/dist/helpers/file-metadata */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/file-metadata.mjs";
